import { dsnApiV2, useDsnApiV2 } from 'services/axios'

export async function getImsToken() {
  const { data } = await dsnApiV2.get('/ims-token', { withCredentials: true })
  return data
}

export const useImsToken = () => {
  const [{ data, loading, error }] = useDsnApiV2('/ims-token', { withCredentials: true })
  return { data, loading, error }
}
